var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal cover-image-edit-modal",
      attrs: {
        id: "cover-image-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cover-image-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.cover_image_edit.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "cover-image-edit-modal__form" }, [
            _c("div", {
              staticClass: "cover-image-edit-modal__cover-img-thumb",
              style: _vm.coverImageStyle
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "cover-image-edit-modal__cover-img-input text-center clickable"
              },
              [
                _c("img", {
                  attrs: { src: "/static/images/icon-camera.png", alt: "" }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "no-display",
                  attrs: {
                    type: "file",
                    accept: "image/png,image/jpeg,image/jpg"
                  },
                  on: { change: _vm.onCoverImageChange }
                })
              ]
            )
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary mt-16" },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.cover_image_edit.message")) +
              "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b843772", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b843772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/CoverImageEditModal.vue
// module id = TcOf
// module chunks = 1